// source: pbtypes/tools/iot_api/device_iot.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var pbtypes_vehicle_dock_client_dock_client_pb = require('../../../pbtypes/vehicle/dock_client/dock_client_pb.js');
goog.object.extend(proto, pbtypes_vehicle_dock_client_dock_client_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var pbtypes_cloud_services_skyperf_skyperf_pb = require('../../../pbtypes/cloud/services/skyperf/skyperf_pb.js');
goog.object.extend(proto, pbtypes_cloud_services_skyperf_skyperf_pb);
var pbtypes_infrastructure_network_utils_iperf_result_pb = require('../../../pbtypes/infrastructure/network_utils/iperf_result_pb.js');
goog.object.extend(proto, pbtypes_infrastructure_network_utils_iperf_result_pb);
var pbtypes_tools_cloud_api_enums_pb = require('../../../pbtypes/tools/cloud_api/enums_pb.js');
goog.object.extend(proto, pbtypes_tools_cloud_api_enums_pb);
var pbtypes_gen_qca_stats_wifi_scan_params_pb = require('../../../pbtypes/gen/qca_stats/wifi_scan_params_pb.js');
goog.object.extend(proto, pbtypes_gen_qca_stats_wifi_scan_params_pb);
var pbtypes_gen_qca_stats_wifi_scan_result_pb = require('../../../pbtypes/gen/qca_stats/wifi_scan_result_pb.js');
goog.object.extend(proto, pbtypes_gen_qca_stats_wifi_scan_result_pb);
goog.exportSymbol('proto.iot_api.DeviceHyperMastFlagGroup', null, global);
goog.exportSymbol('proto.iot_api.DeviceHyperMastFlagGroup.Flag', null, global);
goog.exportSymbol('proto.iot_api.DeviceHyperMastFlagGroupUpdate', null, global);
goog.exportSymbol('proto.iot_api.DeviceIOTClientInfo', null, global);
goog.exportSymbol('proto.iot_api.DeviceNetworkTest', null, global);
goog.exportSymbol('proto.iot_api.DeviceNetworkTest.ConfigCase', null, global);
goog.exportSymbol('proto.iot_api.DeviceNetworkTest.SkyperfConfig', null, global);
goog.exportSymbol('proto.iot_api.DeviceNetworkTestRequest', null, global);
goog.exportSymbol('proto.iot_api.DeviceNetworkTestResult', null, global);
goog.exportSymbol('proto.iot_api.DeviceNetworkTestResult.ResultCase', null, global);
goog.exportSymbol('proto.iot_api.DeviceNetworkTestSpec', null, global);
goog.exportSymbol('proto.iot_api.DeviceNetworkTestSpec.IperfSpec', null, global);
goog.exportSymbol('proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession', null, global);
goog.exportSymbol('proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec', null, global);
goog.exportSymbol('proto.iot_api.DeviceNetworkTestSpec.SpecCase', null, global);
goog.exportSymbol('proto.iot_api.DeviceNetworkTestSpec.Target', null, global);
goog.exportSymbol('proto.iot_api.DeviceNetworkTestSuite', null, global);
goog.exportSymbol('proto.iot_api.DeviceNetworkTestSuiteResult', null, global);
goog.exportSymbol('proto.iot_api.LinkedDevice', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DeviceIOTClientInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.iot_api.DeviceIOTClientInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DeviceIOTClientInfo.displayName = 'proto.iot_api.DeviceIOTClientInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.LinkedDevice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.iot_api.LinkedDevice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.LinkedDevice.displayName = 'proto.iot_api.LinkedDevice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DeviceNetworkTestSpec = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.iot_api.DeviceNetworkTestSpec.oneofGroups_);
};
goog.inherits(proto.iot_api.DeviceNetworkTestSpec, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DeviceNetworkTestSpec.displayName = 'proto.iot_api.DeviceNetworkTestSpec';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.repeatedFields_, null);
};
goog.inherits(proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.displayName = 'proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.iot_api.DeviceNetworkTestSpec.IperfSpec.repeatedFields_, null);
};
goog.inherits(proto.iot_api.DeviceNetworkTestSpec.IperfSpec, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DeviceNetworkTestSpec.IperfSpec.displayName = 'proto.iot_api.DeviceNetworkTestSpec.IperfSpec';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.displayName = 'proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DeviceNetworkTestRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.iot_api.DeviceNetworkTestRequest.repeatedFields_, null);
};
goog.inherits(proto.iot_api.DeviceNetworkTestRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DeviceNetworkTestRequest.displayName = 'proto.iot_api.DeviceNetworkTestRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DeviceNetworkTest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.iot_api.DeviceNetworkTest.oneofGroups_);
};
goog.inherits(proto.iot_api.DeviceNetworkTest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DeviceNetworkTest.displayName = 'proto.iot_api.DeviceNetworkTest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DeviceNetworkTest.SkyperfConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.iot_api.DeviceNetworkTest.SkyperfConfig.repeatedFields_, null);
};
goog.inherits(proto.iot_api.DeviceNetworkTest.SkyperfConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DeviceNetworkTest.SkyperfConfig.displayName = 'proto.iot_api.DeviceNetworkTest.SkyperfConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DeviceNetworkTestSuite = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.iot_api.DeviceNetworkTestSuite.repeatedFields_, null);
};
goog.inherits(proto.iot_api.DeviceNetworkTestSuite, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DeviceNetworkTestSuite.displayName = 'proto.iot_api.DeviceNetworkTestSuite';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DeviceNetworkTestResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.iot_api.DeviceNetworkTestResult.oneofGroups_);
};
goog.inherits(proto.iot_api.DeviceNetworkTestResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DeviceNetworkTestResult.displayName = 'proto.iot_api.DeviceNetworkTestResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DeviceNetworkTestSuiteResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.iot_api.DeviceNetworkTestSuiteResult.repeatedFields_, null);
};
goog.inherits(proto.iot_api.DeviceNetworkTestSuiteResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DeviceNetworkTestSuiteResult.displayName = 'proto.iot_api.DeviceNetworkTestSuiteResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DeviceHyperMastFlagGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.iot_api.DeviceHyperMastFlagGroup.repeatedFields_, null);
};
goog.inherits(proto.iot_api.DeviceHyperMastFlagGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DeviceHyperMastFlagGroup.displayName = 'proto.iot_api.DeviceHyperMastFlagGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DeviceHyperMastFlagGroup.Flag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.iot_api.DeviceHyperMastFlagGroup.Flag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DeviceHyperMastFlagGroup.Flag.displayName = 'proto.iot_api.DeviceHyperMastFlagGroup.Flag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DeviceHyperMastFlagGroupUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.iot_api.DeviceHyperMastFlagGroupUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DeviceHyperMastFlagGroupUpdate.displayName = 'proto.iot_api.DeviceHyperMastFlagGroupUpdate';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DeviceIOTClientInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DeviceIOTClientInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DeviceIOTClientInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceIOTClientInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
linkedDevice: (f = msg.getLinkedDevice()) && proto.iot_api.LinkedDevice.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DeviceIOTClientInfo}
 */
proto.iot_api.DeviceIOTClientInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DeviceIOTClientInfo;
  return proto.iot_api.DeviceIOTClientInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DeviceIOTClientInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DeviceIOTClientInfo}
 */
proto.iot_api.DeviceIOTClientInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.iot_api.LinkedDevice;
      reader.readMessage(value,proto.iot_api.LinkedDevice.deserializeBinaryFromReader);
      msg.setLinkedDevice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DeviceIOTClientInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DeviceIOTClientInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DeviceIOTClientInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceIOTClientInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLinkedDevice();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.iot_api.LinkedDevice.serializeBinaryToWriter
    );
  }
};


/**
 * optional LinkedDevice linked_device = 1;
 * @return {?proto.iot_api.LinkedDevice}
 */
proto.iot_api.DeviceIOTClientInfo.prototype.getLinkedDevice = function() {
  return /** @type{?proto.iot_api.LinkedDevice} */ (
    jspb.Message.getWrapperField(this, proto.iot_api.LinkedDevice, 1));
};


/**
 * @param {?proto.iot_api.LinkedDevice|undefined} value
 * @return {!proto.iot_api.DeviceIOTClientInfo} returns this
*/
proto.iot_api.DeviceIOTClientInfo.prototype.setLinkedDevice = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DeviceIOTClientInfo} returns this
 */
proto.iot_api.DeviceIOTClientInfo.prototype.clearLinkedDevice = function() {
  return this.setLinkedDevice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DeviceIOTClientInfo.prototype.hasLinkedDevice = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.LinkedDevice.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.LinkedDevice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.LinkedDevice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.LinkedDevice.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceType: jspb.Message.getFieldWithDefault(msg, 1, 0),
deviceId: jspb.Message.getFieldWithDefault(msg, 2, ""),
dockType: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.LinkedDevice}
 */
proto.iot_api.LinkedDevice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.LinkedDevice;
  return proto.iot_api.LinkedDevice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.LinkedDevice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.LinkedDevice}
 */
proto.iot_api.LinkedDevice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.cloud_api.IOTDeviceType.IOTDeviceTypeEnum} */ (reader.readEnum());
      msg.setDeviceType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 3:
      var value = /** @type {!proto.dock_client.DockVehiclePairing.DockType} */ (reader.readEnum());
      msg.setDockType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.LinkedDevice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.LinkedDevice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.LinkedDevice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.LinkedDevice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeviceType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDeviceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDockType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional cloud_api.IOTDeviceType.IOTDeviceTypeEnum device_type = 1;
 * @return {!proto.cloud_api.IOTDeviceType.IOTDeviceTypeEnum}
 */
proto.iot_api.LinkedDevice.prototype.getDeviceType = function() {
  return /** @type {!proto.cloud_api.IOTDeviceType.IOTDeviceTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.cloud_api.IOTDeviceType.IOTDeviceTypeEnum} value
 * @return {!proto.iot_api.LinkedDevice} returns this
 */
proto.iot_api.LinkedDevice.prototype.setDeviceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string device_id = 2;
 * @return {string}
 */
proto.iot_api.LinkedDevice.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.iot_api.LinkedDevice} returns this
 */
proto.iot_api.LinkedDevice.prototype.setDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional dock_client.DockVehiclePairing.DockType dock_type = 3;
 * @return {!proto.dock_client.DockVehiclePairing.DockType}
 */
proto.iot_api.LinkedDevice.prototype.getDockType = function() {
  return /** @type {!proto.dock_client.DockVehiclePairing.DockType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.dock_client.DockVehiclePairing.DockType} value
 * @return {!proto.iot_api.LinkedDevice} returns this
 */
proto.iot_api.LinkedDevice.prototype.setDockType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.iot_api.DeviceNetworkTestSpec.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.iot_api.DeviceNetworkTestSpec.SpecCase = {
  SPEC_NOT_SET: 0,
  SKYPERF: 2,
  IPERF: 3
};

/**
 * @return {proto.iot_api.DeviceNetworkTestSpec.SpecCase}
 */
proto.iot_api.DeviceNetworkTestSpec.prototype.getSpecCase = function() {
  return /** @type {proto.iot_api.DeviceNetworkTestSpec.SpecCase} */(jspb.Message.computeOneofCase(this, proto.iot_api.DeviceNetworkTestSpec.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DeviceNetworkTestSpec.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DeviceNetworkTestSpec.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DeviceNetworkTestSpec} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTestSpec.toObject = function(includeInstance, msg) {
  var f, obj = {
skyperf: (f = msg.getSkyperf()) && proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.toObject(includeInstance, f),
iperf: (f = msg.getIperf()) && proto.iot_api.DeviceNetworkTestSpec.IperfSpec.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DeviceNetworkTestSpec}
 */
proto.iot_api.DeviceNetworkTestSpec.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DeviceNetworkTestSpec;
  return proto.iot_api.DeviceNetworkTestSpec.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DeviceNetworkTestSpec} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DeviceNetworkTestSpec}
 */
proto.iot_api.DeviceNetworkTestSpec.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec;
      reader.readMessage(value,proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.deserializeBinaryFromReader);
      msg.setSkyperf(value);
      break;
    case 3:
      var value = new proto.iot_api.DeviceNetworkTestSpec.IperfSpec;
      reader.readMessage(value,proto.iot_api.DeviceNetworkTestSpec.IperfSpec.deserializeBinaryFromReader);
      msg.setIperf(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DeviceNetworkTestSpec.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DeviceNetworkTestSpec.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DeviceNetworkTestSpec} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTestSpec.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSkyperf();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.serializeBinaryToWriter
    );
  }
  f = message.getIperf();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.iot_api.DeviceNetworkTestSpec.IperfSpec.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.iot_api.DeviceNetworkTestSpec.Target = {
  UNKNOWN: 0,
  CLOUD: 1,
  LINKED_DOCK: 2
};


/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.toObject = function(includeInstance, msg) {
  var f, obj = {
sessionDuration: jspb.Message.getFieldWithDefault(msg, 1, 0),
protocolsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
reverse: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec}
 */
proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec;
  return proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec}
 */
proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSessionDuration(value);
      break;
    case 2:
      var values = /** @type {!Array<!proto.skyperf.SkyperfSessionProtocol>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addProtocols(values[i]);
      }
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReverse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionDuration();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getProtocolsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getReverse();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional uint32 session_duration = 1;
 * @return {number}
 */
proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.prototype.getSessionDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec} returns this
 */
proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.prototype.setSessionDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated skyperf.SkyperfSessionProtocol protocols = 2;
 * @return {!Array<!proto.skyperf.SkyperfSessionProtocol>}
 */
proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.prototype.getProtocolsList = function() {
  return /** @type {!Array<!proto.skyperf.SkyperfSessionProtocol>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.skyperf.SkyperfSessionProtocol>} value
 * @return {!proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec} returns this
 */
proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.prototype.setProtocolsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.skyperf.SkyperfSessionProtocol} value
 * @param {number=} opt_index
 * @return {!proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec} returns this
 */
proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.prototype.addProtocols = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec} returns this
 */
proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.prototype.clearProtocolsList = function() {
  return this.setProtocolsList([]);
};


/**
 * optional bool reverse = 3;
 * @return {boolean}
 */
proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.prototype.getReverse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec} returns this
 */
proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec.prototype.setReverse = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DeviceNetworkTestSpec.IperfSpec.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.toObject = function(includeInstance, msg) {
  var f, obj = {
sessionDuration: jspb.Message.getFieldWithDefault(msg, 1, 0),
sessionsList: jspb.Message.toObjectList(msg.getSessionsList(),
    proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec}
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DeviceNetworkTestSpec.IperfSpec;
  return proto.iot_api.DeviceNetworkTestSpec.IperfSpec.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec}
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSessionDuration(value);
      break;
    case 2:
      var value = new proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession;
      reader.readMessage(value,proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.deserializeBinaryFromReader);
      msg.addSessions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DeviceNetworkTestSpec.IperfSpec.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionDuration();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSessionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.toObject = function(includeInstance, msg) {
  var f, obj = {
target: jspb.Message.getFieldWithDefault(msg, 1, 0),
protocol: jspb.Message.getFieldWithDefault(msg, 2, 0),
reverse: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession}
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession;
  return proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession}
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.iot_api.DeviceNetworkTestSpec.Target} */ (reader.readEnum());
      msg.setTarget(value);
      break;
    case 2:
      var value = /** @type {!proto.skyperf.SkyperfSessionProtocol} */ (reader.readEnum());
      msg.setProtocol(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReverse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTarget();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getProtocol();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getReverse();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional Target target = 1;
 * @return {!proto.iot_api.DeviceNetworkTestSpec.Target}
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.prototype.getTarget = function() {
  return /** @type {!proto.iot_api.DeviceNetworkTestSpec.Target} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.iot_api.DeviceNetworkTestSpec.Target} value
 * @return {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession} returns this
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.prototype.setTarget = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional skyperf.SkyperfSessionProtocol protocol = 2;
 * @return {!proto.skyperf.SkyperfSessionProtocol}
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.prototype.getProtocol = function() {
  return /** @type {!proto.skyperf.SkyperfSessionProtocol} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.skyperf.SkyperfSessionProtocol} value
 * @return {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession} returns this
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.prototype.setProtocol = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional bool reverse = 3;
 * @return {boolean}
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.prototype.getReverse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession} returns this
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession.prototype.setReverse = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional uint32 session_duration = 1;
 * @return {number}
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.prototype.getSessionDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec} returns this
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.prototype.setSessionDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated IperfSession sessions = 2;
 * @return {!Array<!proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession>}
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.prototype.getSessionsList = function() {
  return /** @type{!Array<!proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession, 2));
};


/**
 * @param {!Array<!proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession>} value
 * @return {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec} returns this
*/
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.prototype.setSessionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession=} opt_value
 * @param {number=} opt_index
 * @return {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession}
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.prototype.addSessions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.iot_api.DeviceNetworkTestSpec.IperfSpec.IperfSession, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.iot_api.DeviceNetworkTestSpec.IperfSpec} returns this
 */
proto.iot_api.DeviceNetworkTestSpec.IperfSpec.prototype.clearSessionsList = function() {
  return this.setSessionsList([]);
};


/**
 * optional SkyperfSpec skyperf = 2;
 * @return {?proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec}
 */
proto.iot_api.DeviceNetworkTestSpec.prototype.getSkyperf = function() {
  return /** @type{?proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec} */ (
    jspb.Message.getWrapperField(this, proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec, 2));
};


/**
 * @param {?proto.iot_api.DeviceNetworkTestSpec.SkyperfSpec|undefined} value
 * @return {!proto.iot_api.DeviceNetworkTestSpec} returns this
*/
proto.iot_api.DeviceNetworkTestSpec.prototype.setSkyperf = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.iot_api.DeviceNetworkTestSpec.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DeviceNetworkTestSpec} returns this
 */
proto.iot_api.DeviceNetworkTestSpec.prototype.clearSkyperf = function() {
  return this.setSkyperf(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DeviceNetworkTestSpec.prototype.hasSkyperf = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional IperfSpec iperf = 3;
 * @return {?proto.iot_api.DeviceNetworkTestSpec.IperfSpec}
 */
proto.iot_api.DeviceNetworkTestSpec.prototype.getIperf = function() {
  return /** @type{?proto.iot_api.DeviceNetworkTestSpec.IperfSpec} */ (
    jspb.Message.getWrapperField(this, proto.iot_api.DeviceNetworkTestSpec.IperfSpec, 3));
};


/**
 * @param {?proto.iot_api.DeviceNetworkTestSpec.IperfSpec|undefined} value
 * @return {!proto.iot_api.DeviceNetworkTestSpec} returns this
*/
proto.iot_api.DeviceNetworkTestSpec.prototype.setIperf = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.iot_api.DeviceNetworkTestSpec.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DeviceNetworkTestSpec} returns this
 */
proto.iot_api.DeviceNetworkTestSpec.prototype.clearIperf = function() {
  return this.setIperf(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DeviceNetworkTestSpec.prototype.hasIperf = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.iot_api.DeviceNetworkTestRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DeviceNetworkTestRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DeviceNetworkTestRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DeviceNetworkTestRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTestRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
testSpecsList: jspb.Message.toObjectList(msg.getTestSpecsList(),
    proto.iot_api.DeviceNetworkTestSpec.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DeviceNetworkTestRequest}
 */
proto.iot_api.DeviceNetworkTestRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DeviceNetworkTestRequest;
  return proto.iot_api.DeviceNetworkTestRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DeviceNetworkTestRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DeviceNetworkTestRequest}
 */
proto.iot_api.DeviceNetworkTestRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 4:
      var value = new proto.iot_api.DeviceNetworkTestSpec;
      reader.readMessage(value,proto.iot_api.DeviceNetworkTestSpec.deserializeBinaryFromReader);
      msg.addTestSpecs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DeviceNetworkTestRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DeviceNetworkTestRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DeviceNetworkTestRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTestRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTestSpecsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.iot_api.DeviceNetworkTestSpec.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.iot_api.DeviceNetworkTestRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.iot_api.DeviceNetworkTestRequest} returns this
 */
proto.iot_api.DeviceNetworkTestRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated DeviceNetworkTestSpec test_specs = 4;
 * @return {!Array<!proto.iot_api.DeviceNetworkTestSpec>}
 */
proto.iot_api.DeviceNetworkTestRequest.prototype.getTestSpecsList = function() {
  return /** @type{!Array<!proto.iot_api.DeviceNetworkTestSpec>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.iot_api.DeviceNetworkTestSpec, 4));
};


/**
 * @param {!Array<!proto.iot_api.DeviceNetworkTestSpec>} value
 * @return {!proto.iot_api.DeviceNetworkTestRequest} returns this
*/
proto.iot_api.DeviceNetworkTestRequest.prototype.setTestSpecsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.iot_api.DeviceNetworkTestSpec=} opt_value
 * @param {number=} opt_index
 * @return {!proto.iot_api.DeviceNetworkTestSpec}
 */
proto.iot_api.DeviceNetworkTestRequest.prototype.addTestSpecs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.iot_api.DeviceNetworkTestSpec, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.iot_api.DeviceNetworkTestRequest} returns this
 */
proto.iot_api.DeviceNetworkTestRequest.prototype.clearTestSpecsList = function() {
  return this.setTestSpecsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.iot_api.DeviceNetworkTest.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.iot_api.DeviceNetworkTest.ConfigCase = {
  CONFIG_NOT_SET: 0,
  SKYPERF: 2,
  WIFI_SCAN: 3
};

/**
 * @return {proto.iot_api.DeviceNetworkTest.ConfigCase}
 */
proto.iot_api.DeviceNetworkTest.prototype.getConfigCase = function() {
  return /** @type {proto.iot_api.DeviceNetworkTest.ConfigCase} */(jspb.Message.computeOneofCase(this, proto.iot_api.DeviceNetworkTest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DeviceNetworkTest.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DeviceNetworkTest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DeviceNetworkTest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTest.toObject = function(includeInstance, msg) {
  var f, obj = {
skyperf: (f = msg.getSkyperf()) && proto.iot_api.DeviceNetworkTest.SkyperfConfig.toObject(includeInstance, f),
wifiScan: (f = msg.getWifiScan()) && pbtypes_gen_qca_stats_wifi_scan_params_pb.WifiScanParams.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DeviceNetworkTest}
 */
proto.iot_api.DeviceNetworkTest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DeviceNetworkTest;
  return proto.iot_api.DeviceNetworkTest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DeviceNetworkTest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DeviceNetworkTest}
 */
proto.iot_api.DeviceNetworkTest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.iot_api.DeviceNetworkTest.SkyperfConfig;
      reader.readMessage(value,proto.iot_api.DeviceNetworkTest.SkyperfConfig.deserializeBinaryFromReader);
      msg.setSkyperf(value);
      break;
    case 3:
      var value = new pbtypes_gen_qca_stats_wifi_scan_params_pb.WifiScanParams;
      reader.readMessage(value,pbtypes_gen_qca_stats_wifi_scan_params_pb.WifiScanParams.deserializeBinaryFromReader);
      msg.setWifiScan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DeviceNetworkTest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DeviceNetworkTest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DeviceNetworkTest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSkyperf();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.iot_api.DeviceNetworkTest.SkyperfConfig.serializeBinaryToWriter
    );
  }
  f = message.getWifiScan();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_qca_stats_wifi_scan_params_pb.WifiScanParams.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.iot_api.DeviceNetworkTest.SkyperfConfig.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DeviceNetworkTest.SkyperfConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DeviceNetworkTest.SkyperfConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DeviceNetworkTest.SkyperfConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTest.SkyperfConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
sessionDuration: jspb.Message.getFieldWithDefault(msg, 1, 0),
dumpFolder: jspb.Message.getFieldWithDefault(msg, 2, ""),
sessionsList: jspb.Message.toObjectList(msg.getSessionsList(),
    pbtypes_cloud_services_skyperf_skyperf_pb.SkyperfSession.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DeviceNetworkTest.SkyperfConfig}
 */
proto.iot_api.DeviceNetworkTest.SkyperfConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DeviceNetworkTest.SkyperfConfig;
  return proto.iot_api.DeviceNetworkTest.SkyperfConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DeviceNetworkTest.SkyperfConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DeviceNetworkTest.SkyperfConfig}
 */
proto.iot_api.DeviceNetworkTest.SkyperfConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSessionDuration(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDumpFolder(value);
      break;
    case 3:
      var value = new pbtypes_cloud_services_skyperf_skyperf_pb.SkyperfSession;
      reader.readMessage(value,pbtypes_cloud_services_skyperf_skyperf_pb.SkyperfSession.deserializeBinaryFromReader);
      msg.addSessions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DeviceNetworkTest.SkyperfConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DeviceNetworkTest.SkyperfConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DeviceNetworkTest.SkyperfConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTest.SkyperfConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionDuration();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getDumpFolder();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSessionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      pbtypes_cloud_services_skyperf_skyperf_pb.SkyperfSession.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 session_duration = 1;
 * @return {number}
 */
proto.iot_api.DeviceNetworkTest.SkyperfConfig.prototype.getSessionDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.iot_api.DeviceNetworkTest.SkyperfConfig} returns this
 */
proto.iot_api.DeviceNetworkTest.SkyperfConfig.prototype.setSessionDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string dump_folder = 2;
 * @return {string}
 */
proto.iot_api.DeviceNetworkTest.SkyperfConfig.prototype.getDumpFolder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.iot_api.DeviceNetworkTest.SkyperfConfig} returns this
 */
proto.iot_api.DeviceNetworkTest.SkyperfConfig.prototype.setDumpFolder = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated skyperf.SkyperfSession sessions = 3;
 * @return {!Array<!proto.skyperf.SkyperfSession>}
 */
proto.iot_api.DeviceNetworkTest.SkyperfConfig.prototype.getSessionsList = function() {
  return /** @type{!Array<!proto.skyperf.SkyperfSession>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_cloud_services_skyperf_skyperf_pb.SkyperfSession, 3));
};


/**
 * @param {!Array<!proto.skyperf.SkyperfSession>} value
 * @return {!proto.iot_api.DeviceNetworkTest.SkyperfConfig} returns this
*/
proto.iot_api.DeviceNetworkTest.SkyperfConfig.prototype.setSessionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.skyperf.SkyperfSession=} opt_value
 * @param {number=} opt_index
 * @return {!proto.skyperf.SkyperfSession}
 */
proto.iot_api.DeviceNetworkTest.SkyperfConfig.prototype.addSessions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.skyperf.SkyperfSession, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.iot_api.DeviceNetworkTest.SkyperfConfig} returns this
 */
proto.iot_api.DeviceNetworkTest.SkyperfConfig.prototype.clearSessionsList = function() {
  return this.setSessionsList([]);
};


/**
 * optional SkyperfConfig skyperf = 2;
 * @return {?proto.iot_api.DeviceNetworkTest.SkyperfConfig}
 */
proto.iot_api.DeviceNetworkTest.prototype.getSkyperf = function() {
  return /** @type{?proto.iot_api.DeviceNetworkTest.SkyperfConfig} */ (
    jspb.Message.getWrapperField(this, proto.iot_api.DeviceNetworkTest.SkyperfConfig, 2));
};


/**
 * @param {?proto.iot_api.DeviceNetworkTest.SkyperfConfig|undefined} value
 * @return {!proto.iot_api.DeviceNetworkTest} returns this
*/
proto.iot_api.DeviceNetworkTest.prototype.setSkyperf = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.iot_api.DeviceNetworkTest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DeviceNetworkTest} returns this
 */
proto.iot_api.DeviceNetworkTest.prototype.clearSkyperf = function() {
  return this.setSkyperf(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DeviceNetworkTest.prototype.hasSkyperf = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional qca_stats.WifiScanParams wifi_scan = 3;
 * @return {?proto.qca_stats.WifiScanParams}
 */
proto.iot_api.DeviceNetworkTest.prototype.getWifiScan = function() {
  return /** @type{?proto.qca_stats.WifiScanParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_qca_stats_wifi_scan_params_pb.WifiScanParams, 3));
};


/**
 * @param {?proto.qca_stats.WifiScanParams|undefined} value
 * @return {!proto.iot_api.DeviceNetworkTest} returns this
*/
proto.iot_api.DeviceNetworkTest.prototype.setWifiScan = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.iot_api.DeviceNetworkTest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DeviceNetworkTest} returns this
 */
proto.iot_api.DeviceNetworkTest.prototype.clearWifiScan = function() {
  return this.setWifiScan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DeviceNetworkTest.prototype.hasWifiScan = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.iot_api.DeviceNetworkTestSuite.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DeviceNetworkTestSuite.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DeviceNetworkTestSuite.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DeviceNetworkTestSuite} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTestSuite.toObject = function(includeInstance, msg) {
  var f, obj = {
testsList: jspb.Message.toObjectList(msg.getTestsList(),
    proto.iot_api.DeviceNetworkTest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DeviceNetworkTestSuite}
 */
proto.iot_api.DeviceNetworkTestSuite.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DeviceNetworkTestSuite;
  return proto.iot_api.DeviceNetworkTestSuite.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DeviceNetworkTestSuite} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DeviceNetworkTestSuite}
 */
proto.iot_api.DeviceNetworkTestSuite.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.iot_api.DeviceNetworkTest;
      reader.readMessage(value,proto.iot_api.DeviceNetworkTest.deserializeBinaryFromReader);
      msg.addTests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DeviceNetworkTestSuite.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DeviceNetworkTestSuite.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DeviceNetworkTestSuite} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTestSuite.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.iot_api.DeviceNetworkTest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DeviceNetworkTest tests = 1;
 * @return {!Array<!proto.iot_api.DeviceNetworkTest>}
 */
proto.iot_api.DeviceNetworkTestSuite.prototype.getTestsList = function() {
  return /** @type{!Array<!proto.iot_api.DeviceNetworkTest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.iot_api.DeviceNetworkTest, 1));
};


/**
 * @param {!Array<!proto.iot_api.DeviceNetworkTest>} value
 * @return {!proto.iot_api.DeviceNetworkTestSuite} returns this
*/
proto.iot_api.DeviceNetworkTestSuite.prototype.setTestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.iot_api.DeviceNetworkTest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.iot_api.DeviceNetworkTest}
 */
proto.iot_api.DeviceNetworkTestSuite.prototype.addTests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.iot_api.DeviceNetworkTest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.iot_api.DeviceNetworkTestSuite} returns this
 */
proto.iot_api.DeviceNetworkTestSuite.prototype.clearTestsList = function() {
  return this.setTestsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.iot_api.DeviceNetworkTestResult.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.iot_api.DeviceNetworkTestResult.ResultCase = {
  RESULT_NOT_SET: 0,
  SKYPERF_RESULT: 2,
  WIFI_SCAN_RESULT: 3
};

/**
 * @return {proto.iot_api.DeviceNetworkTestResult.ResultCase}
 */
proto.iot_api.DeviceNetworkTestResult.prototype.getResultCase = function() {
  return /** @type {proto.iot_api.DeviceNetworkTestResult.ResultCase} */(jspb.Message.computeOneofCase(this, proto.iot_api.DeviceNetworkTestResult.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DeviceNetworkTestResult.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DeviceNetworkTestResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DeviceNetworkTestResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTestResult.toObject = function(includeInstance, msg) {
  var f, obj = {
skyperfResult: (f = msg.getSkyperfResult()) && pbtypes_infrastructure_network_utils_iperf_result_pb.IperfResult.toObject(includeInstance, f),
wifiScanResult: (f = msg.getWifiScanResult()) && pbtypes_gen_qca_stats_wifi_scan_result_pb.WifiScanResult.toObject(includeInstance, f),
success: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
params: (f = msg.getParams()) && proto.iot_api.DeviceNetworkTest.toObject(includeInstance, f),
index: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DeviceNetworkTestResult}
 */
proto.iot_api.DeviceNetworkTestResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DeviceNetworkTestResult;
  return proto.iot_api.DeviceNetworkTestResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DeviceNetworkTestResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DeviceNetworkTestResult}
 */
proto.iot_api.DeviceNetworkTestResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new pbtypes_infrastructure_network_utils_iperf_result_pb.IperfResult;
      reader.readMessage(value,pbtypes_infrastructure_network_utils_iperf_result_pb.IperfResult.deserializeBinaryFromReader);
      msg.setSkyperfResult(value);
      break;
    case 3:
      var value = new pbtypes_gen_qca_stats_wifi_scan_result_pb.WifiScanResult;
      reader.readMessage(value,pbtypes_gen_qca_stats_wifi_scan_result_pb.WifiScanResult.deserializeBinaryFromReader);
      msg.setWifiScanResult(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 5:
      var value = new proto.iot_api.DeviceNetworkTest;
      reader.readMessage(value,proto.iot_api.DeviceNetworkTest.deserializeBinaryFromReader);
      msg.setParams(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DeviceNetworkTestResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DeviceNetworkTestResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DeviceNetworkTestResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTestResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSkyperfResult();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_infrastructure_network_utils_iperf_result_pb.IperfResult.serializeBinaryToWriter
    );
  }
  f = message.getWifiScanResult();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_qca_stats_wifi_scan_result_pb.WifiScanResult.serializeBinaryToWriter
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getParams();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.iot_api.DeviceNetworkTest.serializeBinaryToWriter
    );
  }
  f = message.getIndex();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional network_utils.IperfResult skyperf_result = 2;
 * @return {?proto.network_utils.IperfResult}
 */
proto.iot_api.DeviceNetworkTestResult.prototype.getSkyperfResult = function() {
  return /** @type{?proto.network_utils.IperfResult} */ (
    jspb.Message.getWrapperField(this, pbtypes_infrastructure_network_utils_iperf_result_pb.IperfResult, 2));
};


/**
 * @param {?proto.network_utils.IperfResult|undefined} value
 * @return {!proto.iot_api.DeviceNetworkTestResult} returns this
*/
proto.iot_api.DeviceNetworkTestResult.prototype.setSkyperfResult = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.iot_api.DeviceNetworkTestResult.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DeviceNetworkTestResult} returns this
 */
proto.iot_api.DeviceNetworkTestResult.prototype.clearSkyperfResult = function() {
  return this.setSkyperfResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DeviceNetworkTestResult.prototype.hasSkyperfResult = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional qca_stats.WifiScanResult wifi_scan_result = 3;
 * @return {?proto.qca_stats.WifiScanResult}
 */
proto.iot_api.DeviceNetworkTestResult.prototype.getWifiScanResult = function() {
  return /** @type{?proto.qca_stats.WifiScanResult} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_qca_stats_wifi_scan_result_pb.WifiScanResult, 3));
};


/**
 * @param {?proto.qca_stats.WifiScanResult|undefined} value
 * @return {!proto.iot_api.DeviceNetworkTestResult} returns this
*/
proto.iot_api.DeviceNetworkTestResult.prototype.setWifiScanResult = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.iot_api.DeviceNetworkTestResult.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DeviceNetworkTestResult} returns this
 */
proto.iot_api.DeviceNetworkTestResult.prototype.clearWifiScanResult = function() {
  return this.setWifiScanResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DeviceNetworkTestResult.prototype.hasWifiScanResult = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool success = 4;
 * @return {boolean}
 */
proto.iot_api.DeviceNetworkTestResult.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.iot_api.DeviceNetworkTestResult} returns this
 */
proto.iot_api.DeviceNetworkTestResult.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional DeviceNetworkTest params = 5;
 * @return {?proto.iot_api.DeviceNetworkTest}
 */
proto.iot_api.DeviceNetworkTestResult.prototype.getParams = function() {
  return /** @type{?proto.iot_api.DeviceNetworkTest} */ (
    jspb.Message.getWrapperField(this, proto.iot_api.DeviceNetworkTest, 5));
};


/**
 * @param {?proto.iot_api.DeviceNetworkTest|undefined} value
 * @return {!proto.iot_api.DeviceNetworkTestResult} returns this
*/
proto.iot_api.DeviceNetworkTestResult.prototype.setParams = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DeviceNetworkTestResult} returns this
 */
proto.iot_api.DeviceNetworkTestResult.prototype.clearParams = function() {
  return this.setParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DeviceNetworkTestResult.prototype.hasParams = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 index = 6;
 * @return {number}
 */
proto.iot_api.DeviceNetworkTestResult.prototype.getIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.iot_api.DeviceNetworkTestResult} returns this
 */
proto.iot_api.DeviceNetworkTestResult.prototype.setIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.iot_api.DeviceNetworkTestSuiteResult.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DeviceNetworkTestSuiteResult.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DeviceNetworkTestSuiteResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DeviceNetworkTestSuiteResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTestSuiteResult.toObject = function(includeInstance, msg) {
  var f, obj = {
resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.iot_api.DeviceNetworkTestResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DeviceNetworkTestSuiteResult}
 */
proto.iot_api.DeviceNetworkTestSuiteResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DeviceNetworkTestSuiteResult;
  return proto.iot_api.DeviceNetworkTestSuiteResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DeviceNetworkTestSuiteResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DeviceNetworkTestSuiteResult}
 */
proto.iot_api.DeviceNetworkTestSuiteResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.iot_api.DeviceNetworkTestResult;
      reader.readMessage(value,proto.iot_api.DeviceNetworkTestResult.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DeviceNetworkTestSuiteResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DeviceNetworkTestSuiteResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DeviceNetworkTestSuiteResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceNetworkTestSuiteResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.iot_api.DeviceNetworkTestResult.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DeviceNetworkTestResult results = 1;
 * @return {!Array<!proto.iot_api.DeviceNetworkTestResult>}
 */
proto.iot_api.DeviceNetworkTestSuiteResult.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.iot_api.DeviceNetworkTestResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.iot_api.DeviceNetworkTestResult, 1));
};


/**
 * @param {!Array<!proto.iot_api.DeviceNetworkTestResult>} value
 * @return {!proto.iot_api.DeviceNetworkTestSuiteResult} returns this
*/
proto.iot_api.DeviceNetworkTestSuiteResult.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.iot_api.DeviceNetworkTestResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.iot_api.DeviceNetworkTestResult}
 */
proto.iot_api.DeviceNetworkTestSuiteResult.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.iot_api.DeviceNetworkTestResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.iot_api.DeviceNetworkTestSuiteResult} returns this
 */
proto.iot_api.DeviceNetworkTestSuiteResult.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.iot_api.DeviceHyperMastFlagGroup.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DeviceHyperMastFlagGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DeviceHyperMastFlagGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DeviceHyperMastFlagGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceHyperMastFlagGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
instance: jspb.Message.getFieldWithDefault(msg, 2, 0),
flagsList: jspb.Message.toObjectList(msg.getFlagsList(),
    proto.iot_api.DeviceHyperMastFlagGroup.Flag.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DeviceHyperMastFlagGroup}
 */
proto.iot_api.DeviceHyperMastFlagGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DeviceHyperMastFlagGroup;
  return proto.iot_api.DeviceHyperMastFlagGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DeviceHyperMastFlagGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DeviceHyperMastFlagGroup}
 */
proto.iot_api.DeviceHyperMastFlagGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInstance(value);
      break;
    case 3:
      var value = new proto.iot_api.DeviceHyperMastFlagGroup.Flag;
      reader.readMessage(value,proto.iot_api.DeviceHyperMastFlagGroup.Flag.deserializeBinaryFromReader);
      msg.addFlags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DeviceHyperMastFlagGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DeviceHyperMastFlagGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DeviceHyperMastFlagGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceHyperMastFlagGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInstance();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getFlagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.iot_api.DeviceHyperMastFlagGroup.Flag.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DeviceHyperMastFlagGroup.Flag.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DeviceHyperMastFlagGroup.Flag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DeviceHyperMastFlagGroup.Flag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceHyperMastFlagGroup.Flag.toObject = function(includeInstance, msg) {
  var f, obj = {
raised: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
value: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DeviceHyperMastFlagGroup.Flag}
 */
proto.iot_api.DeviceHyperMastFlagGroup.Flag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DeviceHyperMastFlagGroup.Flag;
  return proto.iot_api.DeviceHyperMastFlagGroup.Flag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DeviceHyperMastFlagGroup.Flag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DeviceHyperMastFlagGroup.Flag}
 */
proto.iot_api.DeviceHyperMastFlagGroup.Flag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRaised(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DeviceHyperMastFlagGroup.Flag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DeviceHyperMastFlagGroup.Flag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DeviceHyperMastFlagGroup.Flag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceHyperMastFlagGroup.Flag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRaised();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional bool raised = 1;
 * @return {boolean}
 */
proto.iot_api.DeviceHyperMastFlagGroup.Flag.prototype.getRaised = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.iot_api.DeviceHyperMastFlagGroup.Flag} returns this
 */
proto.iot_api.DeviceHyperMastFlagGroup.Flag.prototype.setRaised = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional uint32 value = 2;
 * @return {number}
 */
proto.iot_api.DeviceHyperMastFlagGroup.Flag.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.iot_api.DeviceHyperMastFlagGroup.Flag} returns this
 */
proto.iot_api.DeviceHyperMastFlagGroup.Flag.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp updated_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.iot_api.DeviceHyperMastFlagGroup.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.iot_api.DeviceHyperMastFlagGroup} returns this
*/
proto.iot_api.DeviceHyperMastFlagGroup.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DeviceHyperMastFlagGroup} returns this
 */
proto.iot_api.DeviceHyperMastFlagGroup.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DeviceHyperMastFlagGroup.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.iot_api.DeviceHyperMastFlagGroup.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.iot_api.DeviceHyperMastFlagGroup} returns this
 */
proto.iot_api.DeviceHyperMastFlagGroup.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 instance = 2;
 * @return {number}
 */
proto.iot_api.DeviceHyperMastFlagGroup.prototype.getInstance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.iot_api.DeviceHyperMastFlagGroup} returns this
 */
proto.iot_api.DeviceHyperMastFlagGroup.prototype.setInstance = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated Flag flags = 3;
 * @return {!Array<!proto.iot_api.DeviceHyperMastFlagGroup.Flag>}
 */
proto.iot_api.DeviceHyperMastFlagGroup.prototype.getFlagsList = function() {
  return /** @type{!Array<!proto.iot_api.DeviceHyperMastFlagGroup.Flag>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.iot_api.DeviceHyperMastFlagGroup.Flag, 3));
};


/**
 * @param {!Array<!proto.iot_api.DeviceHyperMastFlagGroup.Flag>} value
 * @return {!proto.iot_api.DeviceHyperMastFlagGroup} returns this
*/
proto.iot_api.DeviceHyperMastFlagGroup.prototype.setFlagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.iot_api.DeviceHyperMastFlagGroup.Flag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.iot_api.DeviceHyperMastFlagGroup.Flag}
 */
proto.iot_api.DeviceHyperMastFlagGroup.prototype.addFlags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.iot_api.DeviceHyperMastFlagGroup.Flag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.iot_api.DeviceHyperMastFlagGroup} returns this
 */
proto.iot_api.DeviceHyperMastFlagGroup.prototype.clearFlagsList = function() {
  return this.setFlagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DeviceHyperMastFlagGroupUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DeviceHyperMastFlagGroupUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DeviceHyperMastFlagGroupUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceHyperMastFlagGroupUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
flagGroup: (f = msg.getFlagGroup()) && proto.iot_api.DeviceHyperMastFlagGroup.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DeviceHyperMastFlagGroupUpdate}
 */
proto.iot_api.DeviceHyperMastFlagGroupUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DeviceHyperMastFlagGroupUpdate;
  return proto.iot_api.DeviceHyperMastFlagGroupUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DeviceHyperMastFlagGroupUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DeviceHyperMastFlagGroupUpdate}
 */
proto.iot_api.DeviceHyperMastFlagGroupUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 2:
      var value = new proto.iot_api.DeviceHyperMastFlagGroup;
      reader.readMessage(value,proto.iot_api.DeviceHyperMastFlagGroup.deserializeBinaryFromReader);
      msg.setFlagGroup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DeviceHyperMastFlagGroupUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DeviceHyperMastFlagGroupUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DeviceHyperMastFlagGroupUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DeviceHyperMastFlagGroupUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeviceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFlagGroup();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.iot_api.DeviceHyperMastFlagGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional string device_id = 1;
 * @return {string}
 */
proto.iot_api.DeviceHyperMastFlagGroupUpdate.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.iot_api.DeviceHyperMastFlagGroupUpdate} returns this
 */
proto.iot_api.DeviceHyperMastFlagGroupUpdate.prototype.setDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional DeviceHyperMastFlagGroup flag_group = 2;
 * @return {?proto.iot_api.DeviceHyperMastFlagGroup}
 */
proto.iot_api.DeviceHyperMastFlagGroupUpdate.prototype.getFlagGroup = function() {
  return /** @type{?proto.iot_api.DeviceHyperMastFlagGroup} */ (
    jspb.Message.getWrapperField(this, proto.iot_api.DeviceHyperMastFlagGroup, 2));
};


/**
 * @param {?proto.iot_api.DeviceHyperMastFlagGroup|undefined} value
 * @return {!proto.iot_api.DeviceHyperMastFlagGroupUpdate} returns this
*/
proto.iot_api.DeviceHyperMastFlagGroupUpdate.prototype.setFlagGroup = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DeviceHyperMastFlagGroupUpdate} returns this
 */
proto.iot_api.DeviceHyperMastFlagGroupUpdate.prototype.clearFlagGroup = function() {
  return this.setFlagGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DeviceHyperMastFlagGroupUpdate.prototype.hasFlagGroup = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.iot_api);
